
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33833',
  depVersions: {
  "documents-public-ui": "static-1.33833",
  "client-types": "static-1.443",
  "documents-lib": "static-1.33838",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1859",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4754",
  "highcharts": "static-8.98",
  "hs-promise-utils": "static-1.5327",
  "hs-test-utils": "static-1.7726",
  "hub-http": "static-1.5872",
  "hubspot-dlb": "static-2.1786",
  "HubStyleTokens": "static-2.11158",
  "I18n": "static-7.1553",
  "jasmine-immutable": "static-1.2755",
  "jasmine-runner": "static-1.6196",
  "lodash": "static-1.3",
  "quartz": "static-1.6632",
  "react": "static-7.176",
  "react-dlb": "static-1.70",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.66",
  "react-rhumb": "static-1.16372",
  "reporting-data": "static-1.66268",
  "reporting-testing-lib": "static-1.8201",
  "reporting-visualizations": "static-1.58344",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4485",
  "webpack-env": "static-1.54",
  "atom": "static-1.4807",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2207",
  "classnames": "static-2.10",
  "crm_schema": "static-3.90919",
  "cssUtils": "static-1.712",
  "customer-data-filters-ui": "static-1.38670",
  "customer-data-objects": "static-1.7361",
  "customer-data-property-utils": "static-1.7808",
  "data-fetching-client": "static-1.9413",
  "enviro": "static-4.387",
  "FireAlarmUi": "static-1.4268",
  "flux-actions": "static-1.302",
  "FormsCommonComponents": "static-1.85146",
  "FormUrlGenerator": "static-2.4467",
  "foundations-components": "static-1.7396",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3873",
  "HubStyle": "static-2.11466",
  "icons": "static-2.618",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6884",
  "metrics-js": "static-1.9346",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.349",
  "property-description-translator": "static-1.3596",
  "property-translator": "static-1.5150",
  "quartz-config": "static-1.410",
  "quartz-core": "static-1.5851",
  "quick-fetch": "static-1.3672",
  "raven": "static-3.5624",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5117",
  "react-virtualized": "static-2.93",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7896",
  "reference-resolvers-lite": "static-1.7827",
  "report-customization-components": "static-1.12321",
  "reporting-enablement": "static-1.21879",
  "reporting-reports": "static-1.65946",
  "reporting-snowflake": "static-1.54886",
  "reporting-ui-components": "static-2.63540",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4349",
  "sales-content-partitioning": "static-1.8671",
  "SalesContentIndexUI": "static-3.8802",
  "sanitize": "static-1.4211",
  "sanitize-text": "static-1.7876",
  "self-service-api": "static-1.9970",
  "SharedI18nStrings": "static-1.179",
  "SharedLegalStrings": "static-1.1471",
  "signup-constants": "static-1.18268",
  "signup-ui-lego-core": "static-1.20278",
  "signup-ui-url-generator": "static-2.7777",
  "styled-components": "static-2.84",
  "StyleGuideUI": "static-3.482",
  "superstore": "static-1.4508",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10731",
  "ui-addon-i18n": "static-1.10866",
  "ui-addon-react-router-dom": "static-1.9283",
  "ui-addon-upgrades": "static-9.17504",
  "ui-asset-management-lib": "static-1.10617",
  "ui-images": "static-2.1073",
  "UIComponents": "static-3.8105",
  "usage-tracker": "static-1.7070",
  "usage-tracker-container": "static-1.7060",
  "usage-tracker-core": "static-1.6920",
  "usage-tracker-public": "static-1.6881",
  "viral-links-lib": "static-1.6760",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven-hubspot": "static-1.5931",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3170",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2909",
  "quartz-webpack": "static-1.2856",
  "ai-components-ui-library": "static-1.8192",
  "amplitude-session-replay-browser": "static-1.54",
  "foundations-assets": "static-1.4568",
  "foundations-theming": "static-1.4143",
  "quartz-auth": "static-1.307",
  "usage-tracker-session-replay": "static-1.4756",
  "foundations-theming-base": "static-1.3128",
  "HeadJS": "static-2.699",
  "framer-motion": "static-1.66",
  "hs-test-utils-bend-plugin": "static-1.2837",
  "msw": "static-1.39",
  "testing-library": "static-1.146",
  "i18n-data": "static-1.215",
  "moment-timezone": "static-5.77",
  "jasmine": "static-4.4067",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7662",
  "graphql": "static-1.76",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3397",
  "persist-promise": "static-1.3428",
  "reporting-client-types": "static-1.2359",
  "hs-story-utils": "static-1.9163",
  "react-flip-move": "static-1.64",
  "hub-http-shared-msw-handlers": "static-1.9315",
  "hubspotter-http": "static-1.4421",
  "sassPrefix": "static-1.150",
  "conversations-skeleton-state": "static-1.6985",
  "crm-message-bus": "static-1.42174",
  "customer-data-filters-ui-msw-helpers": "static-1.21104",
  "customer-data-objects-ui-components": "static-1.12739",
  "customer-data-reference-ui-components": "static-1.12876",
  "customer-data-ui-utilities": "static-1.9561",
  "framework-builder-read-service-client": "static-1.3790",
  "framework-data-schema-quick-fetch": "static-1.6510",
  "framework-data-schema-resolvers": "static-1.6605",
  "inbound-db-properties-service-client": "static-1.3621",
  "multi-account-reference-resolvers": "static-1.705",
  "onboarding-tours": "static-1.16178",
  "reporting-datasets-permissions-lib": "static-1.12879",
  "ui-addon-teams": "static-1.21145",
  "apollo-stack-hubspot": "static-3.80",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67450",
  "customer-data-properties": "static-1.50591",
  "forms-ai-lib": "static-1.3906",
  "forms-utils-lib": "static-1.12056",
  "foundations-components-test-utils": "static-1.4879",
  "react-dnd-compat": "static-1.4360",
  "react-tinymce": "static-1.54463",
  "tinymce-config": "static-2.53589",
  "ui-gdpr-components": "static-1.10083",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3665",
  "floating-ui": "static-1.50",
  "react-aria": "static-1.60",
  "tanstack-table": "static-1.49",
  "trellis-assets": "static-1.1030",
  "ui-fonts": "static-1.420",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.781",
  "mobile-manifest-mixins": "static-1.472",
  "quartz-head": "static-1.297",
  "quartz-i18n": "static-1.307",
  "quartz-routing": "static-1.62",
  "quartz-test": "static-1.307",
  "batch-promise": "static-1.1271",
  "external-options-client-types": "static-1.3926",
  "react-colorpicker": "static-2.9948",
  "copilot-toolkit": "static-1.10378",
  "data-quality-ui-library": "static-1.12181",
  "html-to-image": "static-1.48",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40475",
  "reporting-insights-lib": "static-1.990",
  "reporting-plugins": "static-1.9905",
  "ui-addon-draggable-compat": "static-2.3990",
  "ui-addon-opt": "static-4.8124",
  "ui-shepherd-react": "static-3.9880",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24558",
  "hubspot-apollo-client": "static-1.4616",
  "sales-templates-service-types-lib": "static-1.3936",
  "ui-business-units-lib": "static-1.8758",
  "merchandise-lib": "static-1.256",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5376",
  "salesImages": "static-1.519",
  "ts-schema": "static-1.3847",
  "upgrade-management-service-types": "static-1.4244",
  "timezone-utils": "static-2.4980",
  "bender-build-tools": "static-1.2867",
  "chatspot-core": "static-1.20093",
  "chirp-fetch": "static-1.1618",
  "bend-plugin-foundations-theming": "static-1.2626",
  "stylex": "static-1.26",
  "hubspotter-http-shared-msw-handlers": "static-1.9313",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3566",
  "crm-pipelines-api-client-types": "static-1.3907",
  "multi-currency-client-types": "static-1.3461",
  "getting-started-shared-tasks": "static-1.17717",
  "growth-data-modal": "static-1.5075",
  "growth-onboarding-confetti": "static-1.2792",
  "growth-onboarding-next-action-utils": "static-1.1231",
  "navigation-components": "static-1.17089",
  "onboarding-tours-client": "static-1.4392",
  "onboarding-tours-utils": "static-1.244",
  "ui-shepherd-tracker": "static-1.7261",
  "ui-universal-auth": "static-1.8612",
  "user-context": "static-1.4831",
  "cms-field-types": "static-1.4543",
  "content-icons-ui": "static-1.2132",
  "integrations-lib": "static-1.15226",
  "calling-global-api": "static-1.63477",
  "calling-internal-common": "static-1.31028",
  "calling-lifecycle-internal": "static-1.64859",
  "calling-lifecycle-messages": "static-1.57153",
  "commerce-products-lib": "static-1.8674",
  "crm-links": "static-1.5988",
  "file-manager-components": "static-1.22716",
  "google-libphonenumber": "static-1.32",
  "hs-entities": "static-1.404",
  "inbounddb-objects-service-types": "static-1.3993",
  "meetings-icalendar-utils-lib": "static-1.370",
  "object-builder-ui-client": "static-1.47781",
  "pipeline-validation-client-types": "static-1.3730",
  "property-value-citations": "static-1.1205",
  "pulse": "static-1.235",
  "smart-property-lib": "static-1.5676",
  "tiered-pricing": "static-1.730",
  "ui-addon-iframeable": "static-1.8761",
  "final-form": "static-1.64",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19357",
  "tinymce-themes": "static-1.55559",
  "data-token-picker": "static-1.15950",
  "hub-http-contrib": "static-1.2781",
  "interframe": "static-3.4528",
  "tinymce-data": "static-1.39674",
  "tinymce-plugins": "static-1.56703",
  "ui-addon-sales-email": "static-1.4949",
  "magpie-lib": "static-1.5316",
  "magpie-types": "static-1.4776",
  "simple-logging-lib": "static-1.2787",
  "content-assistance-lib": "static-1.7361",
  "dashboard-lib": "static-1.80374",
  "ExportDialog": "static-6.10123",
  "hubspot-prosemirror": "static-1.17441",
  "hubspot-prosemirror-plugins": "static-1.17433",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8426",
  "campaign-roi-lib": "static-1.8109",
  "feedback-loader": "static-1.28744",
  "onboarding-scopes": "static-1.6184",
  "apollo-link-hub-http": "static-2.4385",
  "hubspot-apollo-cache": "static-1.75",
  "growth-monetization-service-types": "static-1.4260",
  "nav-client-types": "static-1.2072",
  "purchase-motions-api": "static-1.5379",
  "trials-service-types": "static-1.3661",
  "chatspot-client-types": "static-1.10400",
  "idb-keyval": "static-1.38",
  "reactive-lib": "static-1.462",
  "getting-started-shared-tasks-store": "static-1.16835",
  "integrations-error-boundary-lib": "static-1.12641",
  "integrations-tracking-lib": "static-1.5320",
  "native-integrations-shared-strings": "static-1.7525",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10109",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31034",
  "shared-worker-versioning": "static-1.10757",
  "calling-usage-tracker": "static-1.6275",
  "voice-sms-access-library": "static-1.60",
  "customer-data-tracking": "static-1.6602",
  "products-iframe-lib": "static-1.7166",
  "products-ui-components-shared-msw-handlers": "static-1.9697",
  "location-customization-utils-lib": "static-1.8371",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3891",
  "video-components-external": "static-1.10384",
  "video-data-lib": "static-1.34042",
  "directed-graph": "static-1.672",
  "event-emitter": "static-1.667",
  "breeze-intelligence-kit": "static-1.5230",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9398",
  "fsm": "static-1.3468",
  "policy-lib": "static-1.6536",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9461",
  "navigation-messaging": "static-1.6416",
  "FileManagerLib": "static-1.38356",
  "NamespacedHubStyle": "static-2.8840",
  "FileManagerCore": "static-1.38215",
  "codemirror": "static-5.89",
  "layout-dnd-components": "static-1.11928",
  "layout-dnd-utils": "static-1.10903",
  "react-codemirror": "static-1.10347",
  "ui-addon-emoji-picker": "static-1.9626",
  "ui-brand-identity-lib": "static-1.13565",
  "ui-addon-video-player": "static-1.8432",
  "ui-coaching-tips": "static-1.27785",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8302",
  "payment-link-components": "static-1.22771",
  "EmailSignatureEditor": "static-1.23836",
  "eligibility-engine-service-types": "static-1.2942",
  "universal-page-editor-lib": "static-1.2734",
  "calling-orchestration-schema": "static-1.34837",
  "sales-views-client-types": "static-1.4030",
  "crm-record-cards-service-types": "static-1.3394",
  "content-media-composition-data-lib": "static-1.11237",
  "content-media-compositions": "static-2.15244",
  "media-bridge-lib": "static-1.18473",
  "trellis-story-utils": "static-1.4258",
  "storybook-react": "static-1.27",
  "audio-components": "static-1.5525",
  "FileManagerImages": "static-1.35867",
  "video-components": "static-1.12387",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4269",
  "video-embed": "static-1.34876",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67525",
  "layout-data-lib": "static-1.9228",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6322",
  "commerce-tours-lib": "static-1.5621",
  "growth-onboarding-reliability": "static-1.4825",
  "sales-checkout-service-client": "static-1.3426",
  "draft-convert": "static-2.31",
  "draft-extend": "static-3.69",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.21194",
  "sales-email-signature-service-client": "static-1.3579",
  "hls.js": "static-1.33",
  "social-insights-client-types": "static-1.21174",
  "outpost": "static-1.3945",
  "advanced-menus-core": "static-1.14714",
  "advanced-menus-lib": "static-1.11702",
  "ui-memberships-settings-lib": "static-1.33271",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14713",
  "simple-menus-lib": "static-1.16230"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33833",
  "client-types": "/client-types/static-1.443",
  "documents-lib": "/documents-lib/static-1.33838",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1859",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4754",
  "highcharts": "/highcharts/static-8.98",
  "hs-promise-utils": "/hs-promise-utils/static-1.5327",
  "hs-test-utils": "/hs-test-utils/static-1.7726",
  "hub-http": "/hub-http/static-1.5872",
  "hubspot-dlb": "/hubspot-dlb/static-2.1786",
  "HubStyleTokens": "/HubStyleTokens/static-2.11158",
  "I18n": "/I18n/static-7.1553",
  "jasmine-immutable": "/jasmine-immutable/static-1.2755",
  "jasmine-runner": "/jasmine-runner/static-1.6196",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6632",
  "react": "/react/static-7.176",
  "react-dlb": "/react-dlb/static-1.70",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.66",
  "react-rhumb": "/react-rhumb/static-1.16372",
  "reporting-data": "/reporting-data/static-1.66268",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8201",
  "reporting-visualizations": "/reporting-visualizations/static-1.58344",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4485",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4807",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2207",
  "classnames": "/classnames/static-2.10",
  "crm_schema": "/crm_schema/static-3.90919",
  "cssUtils": "/cssUtils/static-1.712",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38670",
  "customer-data-objects": "/customer-data-objects/static-1.7361",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7808",
  "data-fetching-client": "/data-fetching-client/static-1.9413",
  "enviro": "/enviro/static-4.387",
  "FireAlarmUi": "/FireAlarmUi/static-1.4268",
  "flux-actions": "/flux-actions/static-1.302",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85146",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4467",
  "foundations-components": "/foundations-components/static-1.7396",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3873",
  "HubStyle": "/HubStyle/static-2.11466",
  "icons": "/icons/static-2.618",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6884",
  "metrics-js": "/metrics-js/static-1.9346",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "property-description-translator": "/property-description-translator/static-1.3596",
  "property-translator": "/property-translator/static-1.5150",
  "quartz-config": "/quartz-config/static-1.410",
  "quartz-core": "/quartz-core/static-1.5851",
  "quick-fetch": "/quick-fetch/static-1.3672",
  "raven": "/raven/static-3.5624",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5117",
  "react-virtualized": "/react-virtualized/static-2.93",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7896",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7827",
  "report-customization-components": "/report-customization-components/static-1.12321",
  "reporting-enablement": "/reporting-enablement/static-1.21879",
  "reporting-reports": "/reporting-reports/static-1.65946",
  "reporting-snowflake": "/reporting-snowflake/static-1.54886",
  "reporting-ui-components": "/reporting-ui-components/static-2.63540",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4349",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8671",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8802",
  "sanitize": "/sanitize/static-1.4211",
  "sanitize-text": "/sanitize-text/static-1.7876",
  "self-service-api": "/self-service-api/static-1.9970",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1471",
  "signup-constants": "/signup-constants/static-1.18268",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20278",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7777",
  "styled-components": "/styled-components/static-2.84",
  "StyleGuideUI": "/StyleGuideUI/static-3.482",
  "superstore": "/superstore/static-1.4508",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10731",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10866",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9283",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17504",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10617",
  "ui-images": "/ui-images/static-2.1073",
  "UIComponents": "/UIComponents/static-3.8105",
  "usage-tracker": "/usage-tracker/static-1.7070",
  "usage-tracker-container": "/usage-tracker-container/static-1.7060",
  "usage-tracker-core": "/usage-tracker-core/static-1.6920",
  "usage-tracker-public": "/usage-tracker-public/static-1.6881",
  "viral-links-lib": "/viral-links-lib/static-1.6760",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3170",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2909",
  "quartz-webpack": "/quartz-webpack/static-1.2856",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8192",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.54",
  "foundations-assets": "/foundations-assets/static-1.4568",
  "foundations-theming": "/foundations-theming/static-1.4143",
  "quartz-auth": "/quartz-auth/static-1.307",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4756",
  "foundations-theming-base": "/foundations-theming-base/static-1.3128",
  "HeadJS": "/HeadJS/static-2.699",
  "framer-motion": "/framer-motion/static-1.66",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2837",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.146",
  "i18n-data": "/i18n-data/static-1.215",
  "moment-timezone": "/moment-timezone/static-5.77",
  "jasmine": "/jasmine/static-4.4067",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7662",
  "graphql": "/graphql/static-1.76",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3397",
  "persist-promise": "/persist-promise/static-1.3428",
  "reporting-client-types": "/reporting-client-types/static-1.2359",
  "hs-story-utils": "/hs-story-utils/static-1.9163",
  "react-flip-move": "/react-flip-move/static-1.64",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9315",
  "hubspotter-http": "/hubspotter-http/static-1.4421",
  "sassPrefix": "/sassPrefix/static-1.150",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6985",
  "crm-message-bus": "/crm-message-bus/static-1.42174",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21104",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12739",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12876",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9561",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3790",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6510",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6605",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3621",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.705",
  "onboarding-tours": "/onboarding-tours/static-1.16178",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12879",
  "ui-addon-teams": "/ui-addon-teams/static-1.21145",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.80",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67450",
  "customer-data-properties": "/customer-data-properties/static-1.50591",
  "forms-ai-lib": "/forms-ai-lib/static-1.3906",
  "forms-utils-lib": "/forms-utils-lib/static-1.12056",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4879",
  "react-dnd-compat": "/react-dnd-compat/static-1.4360",
  "react-tinymce": "/react-tinymce/static-1.54463",
  "tinymce-config": "/tinymce-config/static-2.53589",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10083",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3665",
  "floating-ui": "/floating-ui/static-1.50",
  "react-aria": "/react-aria/static-1.60",
  "tanstack-table": "/tanstack-table/static-1.49",
  "trellis-assets": "/trellis-assets/static-1.1030",
  "ui-fonts": "/ui-fonts/static-1.420",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.781",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.472",
  "quartz-head": "/quartz-head/static-1.297",
  "quartz-i18n": "/quartz-i18n/static-1.307",
  "quartz-routing": "/quartz-routing/static-1.62",
  "quartz-test": "/quartz-test/static-1.307",
  "batch-promise": "/batch-promise/static-1.1271",
  "external-options-client-types": "/external-options-client-types/static-1.3926",
  "react-colorpicker": "/react-colorpicker/static-2.9948",
  "copilot-toolkit": "/copilot-toolkit/static-1.10378",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12181",
  "html-to-image": "/html-to-image/static-1.48",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40475",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.990",
  "reporting-plugins": "/reporting-plugins/static-1.9905",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.3990",
  "ui-addon-opt": "/ui-addon-opt/static-4.8124",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9880",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24558",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4616",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3936",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8758",
  "merchandise-lib": "/merchandise-lib/static-1.256",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5376",
  "salesImages": "/salesImages/static-1.519",
  "ts-schema": "/ts-schema/static-1.3847",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4244",
  "timezone-utils": "/timezone-utils/static-2.4980",
  "bender-build-tools": "/bender-build-tools/static-1.2867",
  "chatspot-core": "/chatspot-core/static-1.20093",
  "chirp-fetch": "/chirp-fetch/static-1.1618",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2626",
  "stylex": "/stylex/static-1.26",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9313",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3566",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3907",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3461",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17717",
  "growth-data-modal": "/growth-data-modal/static-1.5075",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2792",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1231",
  "navigation-components": "/navigation-components/static-1.17089",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4392",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.244",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7261",
  "ui-universal-auth": "/ui-universal-auth/static-1.8612",
  "user-context": "/user-context/static-1.4831",
  "cms-field-types": "/cms-field-types/static-1.4543",
  "content-icons-ui": "/content-icons-ui/static-1.2132",
  "integrations-lib": "/integrations-lib/static-1.15226",
  "calling-global-api": "/calling-global-api/static-1.63477",
  "calling-internal-common": "/calling-internal-common/static-1.31028",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64859",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57153",
  "commerce-products-lib": "/commerce-products-lib/static-1.8674",
  "crm-links": "/crm-links/static-1.5988",
  "file-manager-components": "/file-manager-components/static-1.22716",
  "google-libphonenumber": "/google-libphonenumber/static-1.32",
  "hs-entities": "/hs-entities/static-1.404",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3993",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.370",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47781",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3730",
  "property-value-citations": "/property-value-citations/static-1.1205",
  "pulse": "/pulse/static-1.235",
  "smart-property-lib": "/smart-property-lib/static-1.5676",
  "tiered-pricing": "/tiered-pricing/static-1.730",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8761",
  "final-form": "/final-form/static-1.64",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19357",
  "tinymce-themes": "/tinymce-themes/static-1.55559",
  "data-token-picker": "/data-token-picker/static-1.15950",
  "hub-http-contrib": "/hub-http-contrib/static-1.2781",
  "interframe": "/interframe/static-3.4528",
  "tinymce-data": "/tinymce-data/static-1.39674",
  "tinymce-plugins": "/tinymce-plugins/static-1.56703",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4949",
  "magpie-lib": "/magpie-lib/static-1.5316",
  "magpie-types": "/magpie-types/static-1.4776",
  "simple-logging-lib": "/simple-logging-lib/static-1.2787",
  "content-assistance-lib": "/content-assistance-lib/static-1.7361",
  "dashboard-lib": "/dashboard-lib/static-1.80374",
  "ExportDialog": "/ExportDialog/static-6.10123",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17441",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17433",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8426",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8109",
  "feedback-loader": "/feedback-loader/static-1.28744",
  "onboarding-scopes": "/onboarding-scopes/static-1.6184",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4385",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.75",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4260",
  "nav-client-types": "/nav-client-types/static-1.2072",
  "purchase-motions-api": "/purchase-motions-api/static-1.5379",
  "trials-service-types": "/trials-service-types/static-1.3661",
  "chatspot-client-types": "/chatspot-client-types/static-1.10400",
  "idb-keyval": "/idb-keyval/static-1.38",
  "reactive-lib": "/reactive-lib/static-1.462",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16835",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12641",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5320",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7525",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10109",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31034",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10757",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6275",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.60",
  "customer-data-tracking": "/customer-data-tracking/static-1.6602",
  "products-iframe-lib": "/products-iframe-lib/static-1.7166",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9697",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8371",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3891",
  "video-components-external": "/video-components-external/static-1.10384",
  "video-data-lib": "/video-data-lib/static-1.34042",
  "directed-graph": "/directed-graph/static-1.672",
  "event-emitter": "/event-emitter/static-1.667",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5230",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9398",
  "fsm": "/fsm/static-1.3468",
  "policy-lib": "/policy-lib/static-1.6536",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9461",
  "navigation-messaging": "/navigation-messaging/static-1.6416",
  "FileManagerLib": "/FileManagerLib/static-1.38356",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8840",
  "FileManagerCore": "/FileManagerCore/static-1.38215",
  "codemirror": "/codemirror/static-5.89",
  "layout-dnd-components": "/layout-dnd-components/static-1.11928",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10903",
  "react-codemirror": "/react-codemirror/static-1.10347",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9626",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13565",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8432",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27785",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8302",
  "payment-link-components": "/payment-link-components/static-1.22771",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23836",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2942",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2734",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34837",
  "sales-views-client-types": "/sales-views-client-types/static-1.4030",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3394",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11237",
  "content-media-compositions": "/content-media-compositions/static-2.15244",
  "media-bridge-lib": "/media-bridge-lib/static-1.18473",
  "trellis-story-utils": "/trellis-story-utils/static-1.4258",
  "storybook-react": "/storybook-react/static-1.27",
  "audio-components": "/audio-components/static-1.5525",
  "FileManagerImages": "/FileManagerImages/static-1.35867",
  "video-components": "/video-components/static-1.12387",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4269",
  "video-embed": "/video-embed/static-1.34876",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67525",
  "layout-data-lib": "/layout-data-lib/static-1.9228",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6322",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5621",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4825",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3426",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-3.69",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.21194",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3579",
  "hls.js": "/hls.js/static-1.33",
  "social-insights-client-types": "/social-insights-client-types/static-1.21174",
  "outpost": "/outpost/static-1.3945",
  "advanced-menus-core": "/advanced-menus-core/static-1.14714",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11702",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33271",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14713",
  "simple-menus-lib": "/simple-menus-lib/static-1.16230"
}
};
